import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type Theme = 'light' | 'dark' | 'system';

interface AppState {
  theme: Theme;
  soundEnabled: boolean;
  hapticsEnabled: boolean;
  
  setTheme: (theme: Theme) => void;
  toggleSound: () => void;
  toggleHaptics: () => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      theme: 'system',
      soundEnabled: true,
      hapticsEnabled: true,
      
      setTheme: (theme) => set({ theme }),
      toggleSound: () => set((state) => ({ soundEnabled: !state.soundEnabled })),
      toggleHaptics: () => set((state) => ({ hapticsEnabled: !state.hapticsEnabled })),
    }),
    {
      name: 'syncabill-app-config', // Legacy name kept for continuity, or change to 'lendlifted.com-config'
      storage: createJSONStorage(() => localStorage),
    }
  )
);
